import { gql } from "apollo-boost";

export const logsAcessoQueries = gql`
query logsAcessoQueries {
    listLogs {
        id
        usuario
        evento
        endereco_ip
        created_at
    }
}`;
